<div class="uk-card uk-card-default uk-width-1-1@xl border-radius-5">
  <h3 class="uk-card-title uk-background-muted k-text-uppercase uk-padding-small k-card-title">
    Planning(s)
  </h3>
  <kendo-grid [data]="planningInfo | async">
    <kendo-grid-column field="date_session" title="DATE" [width]="80"> </kendo-grid-column>
    <kendo-grid-column field="tranche" title="1/2 JOURNÉE" [width]="80"> </kendo-grid-column>
    <kendo-grid-column field="horaires" title="HORAIRES" [width]="80"> </kendo-grid-column>
    <kendo-grid-column field="nom" title="INTERVENANTS" [width]="120"> </kendo-grid-column>
  </kendo-grid>
</div>
